export const getProviderJackpotIdentifier = (providerId, jackpotCode) => {
  return jackpotCode ? `${providerId}_${jackpotCode}` : providerId;
};
